import { Form, type FormItemProps, Input as AntdInput, type InputProps as AntdInputProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';

import { getFormItemLabel } from './utils';

interface InputProps extends FormItemProps, AntdInputProps, Ii18nLabel {
  name: string;
  children: any;
  onReset: any;
}

export const Input = ({ name, label, i18nLabel, rules, disabled, type = 'text', ...props }: InputProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item {...props} name={name} label={fieldLabel} rules={rules}>
      <AntdInput disabled={disabled} type={type} />
    </Form.Item>
  );
};
